export const GET_CUSTOMERS_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_FAILURE = "GET_CUSTOMERS_FAILURE";

export const GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST =
  "GET_CUSTOMER_LINEITEMS_LOOKUP_REQUEST";
export const GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS =
  "GET_CUSTOMER_LINEITEMS_LOOKUP_SUCCESS";
export const GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE =
  "GET_CUSTOMER_LINEITEMS_LOOKUP_FAILURE";

export const GET_CUSTOMER_ADDRESSES_REQUEST = "GET_CUSTOMER_ADDRESSES_REQUEST";
export const GET_CUSTOMER_ADDRESSES_SUCCESS = "GET_CUSTOMER_ADDRESSES_SUCCESS";
export const GET_CUSTOMER_ADDRESSES_FAILURE = "GET_CUSTOMER_ADDRESSES_FAILURE";

export const ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST =
  "ADD_UPDATE_CUSTOMER_LINE_ITEM_REQUEST";
export const ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS =
  "ADD_UPDATE_CUSTOMER_LINE_ITEM_SUCCESS";
export const ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE =
  "ADD_UPDATE_CUSTOMER_LINE_ITEM_FAILURE";

export const ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST =
  "ADD_UPDATE_CUSTOMER_ADDRESS_REQUEST";
export const ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS =
  "ADD_UPDATE_CUSTOMER_ADDRESS_SUCCESS";
export const ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE =
  "ADD_UPDATE_CUSTOMER_ADDRESS_FAILURE";

export const ADD_UPDATE_CUSTOMER_DETAILS_REQUEST =
  "ADD_UPDATE_CUSTOMER_DETAILS_REQUEST";
export const ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS =
  "ADD_UPDATE_CUSTOMER_DETAILS_SUCCESS";
export const ADD_UPDATE_CUSTOMER_DETAILS_FAILURE =
  "ADD_UPDATE_CUSTOMER_DETAILS_FAILURE";
